module.exports = __webpack_public_path__ + "static/img/bg1.18f20f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/photo/bg1.png
// module id = ujGi
// module chunks = 1